import React ,{useState , useEffect} from 'react';

import ButtonSection from '../components/button-section';
import InfoBulle from  '../components/info-bulle';
import RadioBox from '../components/radio-box';
import logo from "../img/logo-bleu.webp";

export default function Enfants(props) {
	const [dataValid, setDataValid] =  useState(false);
	const [errors  , setErrors] = useState([]);
	const [hasEnfantAcharge , setEnfantsACharge] = useState();
	const [hasEnfantGardeAlternee , setEnfantsGardeAlternee] = useState();
	const [nombreEnfantACharge , setNombreEnfantACharge] = useState();
	const [nombreEnfantGardeAlternee , setNombreEnfantGardeAlternee] = useState();
	const {step , restart , simulationData} = props;

	useEffect(()=>{
		setDataValid(isDataValid());
	} ,
	  [
		hasEnfantAcharge
		,hasEnfantGardeAlternee
		,nombreEnfantACharge
		,nombreEnfantGardeAlternee
	  ]
	);
	const goToNextStep = ()=>{
		const errors = getInputErrors();

		if (dataValid){
			const enfants = {
				hasEnfant : hasEnfantAcharge,
				nombreEnfant : hasEnfantAcharge ? nombreEnfantACharge : 0 ,
				hasEnfantGardeAlternee : hasEnfantGardeAlternee,
				nombreEnfantGardeAlternee : hasEnfantGardeAlternee ? nombreEnfantGardeAlternee : 0,
			};
			props.updateData( 'enfants' , enfants);
			props.nextStep();
		} else {
			setErrors(errors);
		}
	};

	const isDataValid = ( )=> {
		return getInputErrors().length === 0;
	}

	const getInputErrors = ()=>{
		const errorGA = 'Veuillez renseigner si vous avez des enfants en garde alternée';
		const errorNEnfant = 'Veuillez saisir le nombre d\'enfants a votre charge';
		const errorNGA= 'Veuillez saisi le nombre de vos enfants en garde alternée';
		const errorEnfant  = 'Veuillez renseigner si vous avez des enfants à charge';
		let errors = [];
		if (hasEnfantAcharge === undefined){
			errors.push(errorEnfant);

		} else {
			if ( hasEnfantAcharge && isNaN(nombreEnfantACharge)){
				errors.push(errorNEnfant);
			}
		} 
		if (hasEnfantGardeAlternee === undefined) {
			errors.push(errorGA);
		}else {
			if ( hasEnfantGardeAlternee && isNaN(nombreEnfantGardeAlternee)){
				errors.push(errorNGA);
			}
		}
		
		setDataValid(!(errors.length > 0 ));
		return errors;
	}
	
	const updateEnfantACharge = (newValue) => (setEnfantsACharge(JSON.parse(newValue)));
	const updateGardeAlternee = (newValue) => (setEnfantsGardeAlternee(JSON.parse(newValue)));

	const updateNombreEnfantACharge = (e)=>{
		const newValue = parseInt(e.target.value);
		setNombreEnfantACharge(newValue);
	}

	const updateNombreGardeAlternee = (e)=>{
		const newValue = parseInt(e.target.value);
		setNombreEnfantGardeAlternee(newValue);
	}

	const InfoEnfantACharge = <p>Il s'agit des personnes de moins de 25 ans ou handicapées dont vous assumez la responsabilité, même sans lien de parenté.</p>;

	return <div id="enfants" className="sim-form min-height" >

		<div className="container">
			<div className="question-set half" >
				<RadioBox 
					model = {{hasEnfantAcharge}}
					handler={ updateEnfantACharge}
					options = {{
						"Oui": true,
						"Non":false
					}}
				>Avez-vous des enfants à charge (hors garde alternée) ? <InfoBulle message={InfoEnfantACharge}/></RadioBox>

			</div>
			{(hasEnfantAcharge)?
				<div className="question-set half">
					<div className="question">
						<label>Saisissez le nombre d'enfants à votre charge</label>
					</div>
					<div className="input">
						<input type="number" className="form-control" onChange={updateNombreEnfantACharge}/>
					</div>
				</div> :""
			}
			<div style={{clear:"both"}}></div>
			<div className="question-set half" >
				<RadioBox 
					model = {{hasEnfantGardeAlternee}}
					handler={ updateGardeAlternee}
					options = {{
						"Oui": true,
						"Non":false
					}}
				>Avez-vous des enfants en garde alternée ?</RadioBox>

			</div>
			{(hasEnfantGardeAlternee)?
				<div className="question-set half">
					<div className="question">
						<label>Saisissez le nombre d'enfants à votre charge</label>
					</div>
					<div className="input">
						<input type="number" className="form-control" onChange={updateNombreGardeAlternee}/>
					</div>
				</div> :""
			}

			
		</div>
		<ButtonSection
			restart={restart}
			action={goToNextStep}
			dataValid= {dataValid}
			errors={errors}
			data={simulationData}
			step={step}
		> 
		</ButtonSection>
	<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</div>;

}